import { createSelector } from '@reduxjs/toolkit';
import { selectHasPhoto } from 'shared/selectors/jsonQuery';

export const selectHasPhotoFilter = createSelector(selectHasPhoto, value => ({
  label: 'Фото',
  value: Boolean(value),
}));
